import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { FeatureFlagConstant } from '@fp/constant/feature-flag-constants';
import { RouterConstant } from '@fp/constant/routerconstant';
import { FeatureFlagService } from '@fp/services';
import { getCurrentUser } from 'aws-amplify/auth';


@Injectable({ providedIn: 'root' })
export class FeatureFlagGuard implements CanActivate {
  private pathToFeatureFlag: Record<string, string> = {
    manageusers: FeatureFlagConstant.UNVERIFIED_USERS,
    [RouterConstant.ROUTER_VISITATION_TRENDS]: FeatureFlagConstant.VISITATION_TRENDS,
  };

  constructor(
    private router: Router,
    private featureFlagService: FeatureFlagService,
  ) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const path = route.routeConfig?.path
    const featureKey = this.pathToFeatureFlag[path];
    if (!featureKey) return true // Allow if no path (e.g. root /)

    const isEnabled = await this.featureFlagService.isFeatureEnabled(
      featureKey,
    );
    if (!isEnabled) {
      const user = await getCurrentUser();
      if (user) {
        this.router.navigate(['/dashboard']);
      } else {
        this.router.navigate(['/login']);
      }
    }

    return true
  }
}